__turbopack_context__.v({
  "container": "Header-module-scss-module__RkrqdW__container",
  "line-break": "Header-module-scss-module__RkrqdW__line-break",
  "logo": "Header-module-scss-module__RkrqdW__logo",
  "menu": "Header-module-scss-module__RkrqdW__menu",
  "text-align_center": "Header-module-scss-module__RkrqdW__text-align_center",
  "userInfo": "Header-module-scss-module__RkrqdW__userInfo",
});
